import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import classnames from "classnames";
import { Collapse, NavbarBrand, Navbar, Nav, Container, NavItem, NavLink } from "reactstrap";
import NavbarItem from "./NavbarItem";
import Dropdown from "react-multilevel-dropdown";
import LaguageBar from "./LanguageBar";

import { staticData } from "managers/staticDataManager";

function PublicNavbar() {
  // const state = useSelector((state) => state);
  const history = useHistory();
  const { language } = useSelector(state => state.account);
  const {isChannelInitialized, channel} = useSelector(state => state.staticData);
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    // window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  const getMenuData = (lng) => {
    let term = channel && channel.localizedTerms
        ? channel.localizedTerms.find(lt => {
            return lt.languageId === lng.languageId
          })
        : null;
    
    if (term
      && term.menuJson) {
        return JSON.parse(term.menuJson);
      }
    
    return [];
  }

  const handleClick = (e, item) => {
    if (!item?.url){
      return;
    }
    // console.log('NavbarItem.handleClick: ', e, item);
    history.push(`${item.url}`);
  }

  const generateAboutLink = () => {
    if (language?.code?.length >= 2){
      let locale = language.code.slice(0, 2).toLowerCase();
      return `/about/${locale}`;
    }

    return `/about`;
  }

  return (
    <Navbar fixed="" color-on-scroll="300" expand="lg" className="d-flex flex-column" style={{backgroundColor: "#EBECF0" }}>
      <div className="header-panel-container w-100">
        <Container className="container-sm">
          <Nav className="w-100">
            <NavItem>
              <NavLink href="https://mse.mk" target="_blank" className="header-panel__link font-weight-bold" >{staticData.loadTerms(useSelector, "ISSUER_NAVBAR_MSE_LABEL")}</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="http://bestnet.com.mk" target="_blank" className="header-panel__link font-weight-bold">{staticData.loadTerms(useSelector, "ISSUER_NAVBAR_BESTNET_LABEL")}</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={generateAboutLink()} className="header-panel__link font-weight-bold">{staticData.loadTerms(useSelector, "ISSUER_NAVBAR_ABOUT_LABEL")}</NavLink>
            </NavItem>
            <LaguageBar  />
          </Nav>
        </Container>
      </div>
        <Container className="container-sm">
          <div className="navbar-translate">
            <NavbarBrand
              data-placement="bottom"
              href="/"
              title="by MSE"
              margin-left="10px"
            >
              {channel?.code}
            </NavbarBrand>
            <button
                aria-expanded={navbarCollapse}
                className={classnames("navbar-toggler navbar-toggler", {
                    toggled: navbarCollapse,
                })}
                onClick={toggleNavbarCollapse}
            >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <Collapse
            className="justify-content-end" 
            navbar
            isOpen={navbarCollapse}
          >
            <Nav navbar>
              {
                isChannelInitialized
                  ?getMenuData(language).map((item) => 
                    item.children
                    ?<Dropdown style={{"whiteSpace": "normal"}} key={item.id} data-key={`${item.url}`} title={item.title} onClick={(e) => handleClick(e, item)} buttonVariant="tertiary" >
                        <NavbarItem data={item.children} />
                    </Dropdown>
                    :<NavLink href="#" key={item.id} data-key={`${item.url}`} title={item.title} onClick={(e) => handleClick(e, item)} className="header-panel__link font-weight-bold" >{item.title}</NavLink>
                  )
                  :null
              }
            </Nav>
          </Collapse>
        </Container>
    </Navbar>
  );
}

export default PublicNavbar;
